import { queryOptions } from '@tanstack/react-query'
import { getDocument, listDocumentProposals, listDocuments } from '../lib/api'

export const documentKeys = {
	all: ['documents'] as const,
	list: () => [...documentKeys.all, 'list'] as const,
	detail: (slug: string) => [...documentKeys.all, 'detail', slug] as const,
	proposals: () => [...documentKeys.all, 'proposals'] as const,
}

export const documentsQuery = () => queryOptions({ queryKey: documentKeys.list(), queryFn: listDocuments })

export const documentQuery = (slug: string) => queryOptions({ queryKey: documentKeys.detail(slug), queryFn: () => getDocument(slug) })

export const documentProposalsQuery = () => queryOptions({ queryKey: documentKeys.proposals(), queryFn: listDocumentProposals })
